import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import BackComponent from 'screens/back';
import { Table, Pagination, Tooltip, Input, CheckboxTable, Modal, Select } from 'components';
import { TrashIcon, EditIcon, CleanIcon, AddWhiteIcon, TrashWhiteIcon, ConfirmIcon, StarIcon } from 'assets/icons';
import { Globals, checkPermission, Constants } from 'utils';
import { AccessoryService } from 'services';
import CreateAccessory from './create-accessory';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

const INITIAL_STATE = {
	search: '',
	category_id: ''
}

class Accessories extends React.Component<Props> {

	timer: any = undefined;

	state = {
		form: INITIAL_STATE,
		page: 1,
		last_page: 1,
		data: [],
		header: [
			'Nombre',
			'Precio',
			'Acciones'
		],
		visible: false,
		item: null,
		services: []
	}

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Complementos',
				onBack: null
			}
		});

		this.props.dispatch({
			type: 'SET_SUBHEADER',
			payload: {
				title: ''
			}
		});

		this.load();
		this.loadServices();
	}

	loadServices = async () => {
		const res: any = await AccessoryService.admin.getServices({
			withoutLoading: true
		});
		this.setState({
			services: res.services || []
		});
	}

	load = async (withoutLoading: boolean = false) => {
		const res: any = await AccessoryService.admin.get({
			withoutLoading,
			page: this.state.page,
			...this.state.form,
		});
		this.setState({
			data: res.accessories.rows,
			last_page: res.accessories.count
		});
	}

	reset = () => {
		this.setState({
			form: INITIAL_STATE,
			page: 1
		},() => this.load(true));
	}

	edit = (e: any, item: any) => {
		e.preventDefault();
		this.setState({
			visible: true,
			item
		});
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	add = () => {
		this.setState({
			visible: true
		});
	}

	onClose = () => {
		this.setState({
			visible: false,
			item: null
		},() => this.load(true));
	}

	delete = async (e: any, item: any) => {
		e.preventDefault();
		Globals.confirm('¿Desea eliminar el complemento?',async () => {
			await AccessoryService.admin.delete({
				accessory_id: item.id
			});
			this.load(true);
		});
	}

	render() {
		const { visible } = this.state;

		return (
			<div id="moderators" className="admin-accessories">
				<BackComponent />

				<div className={ `container-modal-right ${ visible ? 'active' : '' }` }>
					{
						visible && (
							<CreateAccessory
								item={ this.state.item }
								title={ `${ this.state.item ? 'Editar' : 'Añadir' } Complemento` }
								onClose={ () => this.onClose() }
							/>
						)
					}
				</div>

				<div className="row row-filter">
					<div className="col-md-8">
						<div className="row">
							<div className="col-md-5">
								<Input
									searchLeft
									value={ this.state.form.search }
									name="search"
									placeholder="Nombre"
									className="input-table"
									onSubmit={ () => this.load() }
									onChange={ (e: any) => {
										clearTimeout(this.timer);
										this.timer = setTimeout(() => {
											this.load(true);
										},1000);
										this.change(e); 
									} } />
							</div>
							<div className="col-md-5">
								<Select
									placeholder="Categoría"
									name="category_id"
									onChange={ (e: any) => this.change(e,() => {
										this.load(true);
									}) }
									value={ this.state.form.category_id }
									options={ this.state.services.map((item: any) => {
										return {
											value: item.id,
											label: item.name
										}
									}) } />
							</div>
							<div className="col-md-2">
								{
									this.state.form != INITIAL_STATE && (
										<button className="btn btn-clean" onClick={ () => this.reset() }>
											<img src={ CleanIcon } />
										</button>
									)
								}
							</div>
						</div>
					</div>
					<div className="col-md-4 text-right">
						{
							checkPermission(Constants.MODULES.ACCESSORIES,'write') && (
								<button className="btn btn-add" onClick={ () => this.add() }>
									<img src={ AddWhiteIcon } />
								</button>
							)
						}
					</div>
				</div>

				<Table data={ this.state.data.length } header={ this.state.header }>
					{ this.state.data.map((i: any,index: number) => {
						return (
							<tr key={ index }>
								<td>{ i.name }</td>
								<td>{ Globals.formatMiles(i.price) }</td>
								<td>
									{
										checkPermission(Constants.MODULES.ACCESSORIES,'write') && (
											<Tooltip title="Editar">
												<a className="link-icon" href="#" onClick={ (e: any) => this.edit(e,i) }>
													<img src={ EditIcon } />
												</a>
											</Tooltip>
										)
									}
									{
										checkPermission(Constants.MODULES.ACCESSORIES,'delete') && (
											<Tooltip title="Eliminar">
												<a className="link-icon" href="#" onClick={ (e: any) => this.delete(e,i) }>
													<img src={ TrashIcon } />
												</a>
											</Tooltip>
										)
									}
								</td>
							</tr>
						)
					}) }
				</Table>

				<Pagination 
					pages={ this.state.last_page } 
					active={ this.state.page }
					onChange={ async (page: number) => {
						await this.setState({
							page: page
						});
						this.load();
					} } />
			</div>
		)
	}
}

export default connect()(Accessories);